<template>
	<div class="actions">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<div v-if="!previewLicenseDialog">
			<div v-if="show_list_action_page == '1'">
				<el-card shadow="none" style="border-radius: 6px; margin-top: 5px">
					<div style="display: flex; justify-content: center">
						<div>
							<div style="font-weight: 600">Total</div>
							<div style="color: #d26300; font-weight: bold; cursor: pointer">
								{{ actionSummaryData ? actionSummaryData.total : "-" }}
							</div>
						</div>
						<!-- <div style="margin-left: 100px">
							<div style="font-weight: 600">Submitted</div>
							<div style="color: #d26300; font-weight: bold; cursor: pointer">
								{{ actionSummaryData ? actionSummaryData.submitted : "-" }}
							</div>
						</div> -->
						<!-- <div style="margin-left: 100px">
							<div style="font-weight: 600">Pending</div>
							<div style="color: #d26300; font-weight: bold; cursor: pointer">
								{{
									actionSummaryData
										? actionSummaryData.total - actionSummaryData.submitted
										: "-"
								}}
							</div>
						</div> -->
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Pending</div>
							<div style="color: #d26300; font-weight: bold">
								{{
									actionSummaryData
										? actionSummaryData.total - actionSummaryData.approved
										: "-"
								}}
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Completion %</div>
							<div style="color: #d26300; font-weight: bold">
								{{
									actionSummaryData
										? (
												(actionSummaryData.approved / actionSummaryData.total) *
												100
										  ).toFixed(2)
										: "-"
								}}
								%
							</div>
						</div>
						<div style="margin-left: 100px">
							<div style="font-weight: 600">Overdue</div>
							<div style="color: #d26300; font-weight: bold; cursor: pointer">
								{{ actionSummaryData ? actionSummaryData.overdue : "-" }}
							</div>
						</div>
					</div>
				</el-card>
				<div style="display: flex">
					<!-- <div style="width: 25%">
						<div style="margin-top: 20px">Location</div>
						<el-select
							class="select"
							v-model="location"
							@change="
								list_actions_page1(
									currentPage,
									perPage,
									selected_project,
									selectedLocation,
									selected_designation,
									selected_grade,
									selected_status,
									search
								)
							"
							filterable
							placeholder="Select Location"
							style="text-transform: capitalize; margin-top: 10px"
						>
							<el-option
								v-for="item in locationItems"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</div> -->
					<div style="flex: 0 0 25%; margin-top: 10px">
						<div
							style="
								display: flex;
								justify-content: space-between;
								align-items: center;
							"
						>
							<div style="margin-left: 10px">Location</div>
							<div style="display: flex; align-items: center">
								<span
									@click="selectedLocationType = 'location'"
									style="font-size: 13px; cursor: pointer; margin-left: 20px"
									:style="
										selectedLocationType == 'location'
											? 'text-decoration: underline;color:#d26300;font-weight:bolder'
											: 'color:#d26300;'
									"
								>
									All Locations
								</span>
								<span style="color: #d26300; margin: 0 10px"> | </span>
								<span
									@click="selectedLocationType = 'region'"
									style="font-size: 13px; cursor: pointer; margin-right: 10px"
									:style="
										selectedLocationType == 'region'
											? 'text-decoration: underline;color:#d26300;font-weight:bolder'
											: 'color:#d26300;'
									"
								>
									Region
								</span>
							</div>
						</div>
						<div>
							<el-cascader
								v-if="selectedLocationType == 'region'"
								popper-class="custom-cascader"
								style="width: 100%; margin-top: 5px; text-transform: capitalize"
								placeholder="Select Locations"
								:options="locationItems"
								:props="{
									multiple: true,
									checkStrictly: true,
									expandTrigger: 'hover',
								}"
								v-model="location"
								filterable
								clearable
								:collapse-tags="true"
								id="cascader"
								@change="
									list_actions_page1(
										currentPage,
										perPage,
										selected_project,
										selectedLocation,
										selected_designation,
										selected_grade,
										selected_status,
										search
									);
									listSummaryData();
									list_all_filters();
								"
							></el-cascader>
							<el-select
								v-if="selectedLocationType == 'location'"
								style="margin-top: 5px; text-transform: capitalize"
								class="select"
								v-model="location"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select Locations"
								@change="
									list_actions_page1(
										currentPage,
										perPage,
										selected_project,
										selectedLocation,
										selected_designation,
										selected_grade,
										selected_status,
										search
									);
									listSummaryData();
									list_all_filters();
								"
								:collapse-tags="true"
							>
								<el-option
									v-for="(item, key) in allLocations"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div style="flex: 0 0 20%; margin-top: 10px; margin-left: 20px">
						<div style="margin-left: 10px">Date</div>
						<el-date-picker
							ref="datePickerRef"
							style="margin-top: 5px"
							v-model="dates"
							:type="datePickerType"
							class="date"
							unlink-panels
							range-separator="-"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							:picker-options="pickerOptions"
							@picker-change="handlePickerClose('1')"
							@change="handlePickerClose('1')"
						>
						</el-date-picker>
					</div>
					<div style="width: 25%; margin-left: 30px">
						<div style="margin-top: 5px">Projects</div>
						<el-select
							class="select"
							v-model="projectsTasks"
							@change="
								list_actions_page1(
									currentPage,
									perPage,
									selected_project,
									selectedLocation,
									selected_designation,
									selected_grade,
									selected_status,
									search
								);
								listSummaryData();
								list_all_filters();
							"
							filterable
							placeholder="Select Location"
							style="text-transform: capitalize; margin-top: 10px"
						>
							<el-option
								v-for="item in projectsTasksItems"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</div>
					<div style="width: 25%"></div>
					<div
						class="search-col"
						style="width: 30%; margin-top: 30px; margin-left: 20px"
					>
						<input
							type="text"
							v-model="search"
							placeholder="Search Project"
							class="searchicon"
							@input="handleInput"
						/>
					</div>
				</div>
				<div class="actions-table" style="margin-top: 20px">
					<el-table
						v-if="tableVisible"
						:data="
							computedActionTableData.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
						"
					>
						<!-- <el-table-column prop="completed_on">
							<template slot="header" slot-scope="scope">
								Completed On
								<span slot="reference" class="cursor-pointer">
									<i
										v-if="last_completed_on_order == 'dsc'"
										class="el-icon-caret-top"
										style="font-size: 12px"
										@click="
											last_completed_on_order = 'asc';
											completedOn_order = '';
											last_grade_order = '';
										"
									></i>
									<i
										v-if="
											last_completed_on_order == '' ||
											last_completed_on_order == 'asc'
										"
										class="el-icon-caret-bottom"
										style="font-size: 12px"
										@click="
											last_completed_on_order = 'dsc';
											completedOn_order = '';
											last_grade_order = '';
										"
									></i>
								</span>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.completed_on != null
											? moment(scope.row.completed_on).format(
													"Do MMM YYYY, HH:mm a"
											  )
											: "-"
									}}
								</div>
							</template>
						</el-table-column> -->

						<el-table-column width="400px" label="Location">
							<template slot="header" slot-scope="scope">
								Location
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searchedLocation"
										size="mini"
										placeholder="Search Location"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selectedLocation">
											<el-checkbox
												v-for="(project, index) in uniqueLocationNames.filter(
													(el) =>
														!searchedLocation ||
														el
															.toLowerCase()
															.includes(searchedLocation.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="project"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selectedLocation = [...uniqueLocationNames]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selectedLocation = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selectedLocation.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div
									@click="action_row_click(scope.row)"
									style="
										text-transform: capitalize;
										color: #d26300;
										cursor: pointer;
										word-break: break-word;
									"
								>
									<u>{{
										scope.row.location != null ? scope.row.location : "-"
									}}</u>
								</div>
							</template>
						</el-table-column>
						<el-table-column width="400px" label="name">
							<template slot="header" slot-scope="scope">
								Project
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_project"
										size="mini"
										placeholder="Search Project"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_project">
											<el-checkbox
												v-for="(project, index) in uniqueProjectNames.filter(
													(el) =>
														!searched_project ||
														el
															.toLowerCase()
															.includes(searched_project.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="project"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_project = [...uniqueProjectNames]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_project = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_project.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{ scope.row.name }}
								</div>
							</template>
						</el-table-column>
						<!-- <el-table-column label="Designation">
							<template slot="header" slot-scope="scope">
								Designation
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_designation"
										size="mini"
										placeholder="Search Designation"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_designation">
											<el-checkbox
												v-for="(
													Designation, index
												) in uniqueDesignationNames.filter(
													(el) =>
														!searched_designation ||
														el
															.toLowerCase()
															.includes(searched_designation.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="Designation"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="
												selected_designation = [...uniqueDesignationNames]
											"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_designation = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_designation.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.designation != null ? scope.row.designation : "-"
									}}
								</div>
							</template>
						</el-table-column> -->
						<!-- <el-table-column width="120px" prop="points" label="Total Points">
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{ scope.row.total }} of {{ scope.row.total_score }}
								</div>
							</template>
						</el-table-column> -->
						<el-table-column prop="score_perc">
							<template slot="header" slot-scope="scope">
								Completed On
								<span slot="reference" class="cursor-pointer">
									<i
										v-if="completedOn_order == 'dsc'"
										class="el-icon-caret-top"
										style="font-size: 12px"
										@click="
											completedOn_order = 'asc';
											last_completed_on_order = '';
											last_grade_order = '';
										"
									></i>
									<i
										v-if="completedOn_order == '' || completedOn_order == 'asc'"
										class="el-icon-caret-bottom"
										style="font-size: 12px"
										@click="
											completedOn_order = 'dsc';
											last_completed_on_order = '';
											last_grade_order = '';
										"
									></i>
								</span>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.completed_on != null
											? moment(scope.row.completed_on).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="Due Date" prop="due_date">
							<template slot="header" slot-scope="scope">
								Due Date
								<span slot="reference" class="cursor-pointer">
									<i
										v-if="dueDate_order == 'dsc'"
										class="el-icon-caret-top"
										style="font-size: 12px"
										@click="
											dueDate_order = 'asc';
											last_completed_on_order = '';
											last_grade_order = '';
											completedOn_order = '';
										"
									></i>
									<i
										v-if="dueDate_order == '' || dueDate_order == 'asc'"
										class="el-icon-caret-bottom"
										style="font-size: 12px"
										@click="
											dueDate_order = 'dsc';
											last_completed_on_order = '';
											last_grade_order = '';
											completedOn_order = '';
										"
									></i>
								</span>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.due_date != null
											? moment(scope.row.due_date).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<!-- <el-table-column width="100px" label="Grade">
							<template slot="header" slot-scope="scope">
								Grade
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_grade"
										size="mini"
										placeholder="Search Grade"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_grade">
											<el-checkbox
												v-for="(grade, index) in uniqueGradeNames.filter(
													(el) =>
														!searched_grade ||
														el
															.toLowerCase()
															.includes(searched_grade.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="grade"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_grade = [...uniqueGradeNames]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_grade = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_grade.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{ scope.row.grade != null ? scope.row.grade : "-" }}
								</div>
							</template>
						</el-table-column> -->
						<el-table-column width="120px" prop="status">
							<template slot="header" slot-scope="scope">
								Status
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_status"
										size="mini"
										placeholder="Search Status"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_status">
											<el-checkbox
												v-for="(status, index) in uniqueStatus.filter(
													(el) =>
														!searched_status ||
														el
															.toLowerCase()
															.includes(searched_status.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="status"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueStatus.filter(
												(el) =>
													!searched_status ||
													el
														.toLowerCase()
														.includes(searched_status.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_status = [...uniqueStatus]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_status = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_status.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<el-tag
									size="small"
									style="
										border-radius: 12px;
										width: 80px;
										text-align: center;
										text-transform: capitalize;
									"
									:style="
										scope.row.status != 'open' &&
										scope.row.status != 'pending' &&
										scope.row.status != 'overdue' &&
										scope.row.status != 'rejected'
											? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
											: 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
									"
									>{{ scope.row.status }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column>
							<template slot-scope="scope">
								<div
									@click="downloadCsvReport(scope.row)"
									v-if="scope.row.completed > 0"
									style="
										text-transform: capitalize;
										word-break: break-word;
										color: #d26300;
										cursor: pointer;
									"
								>
									<u>Download Report</u>
								</div>
							</template>
						</el-table-column>
						<!-- <el-table-column width="100px">
							<template slot-scope="scope">
								<div
									@click="action_row_click(scope.row)"
									style="
										text-transform: capitalize;
										word-break: break-word;
										color: #d26300;
										cursor: pointer;
									"
								>
									<u>Action Plan</u>
								</div>
							</template>
						</el-table-column> -->
					</el-table>
				</div>
				<el-row :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
							{{ list_count }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPage"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							v-model="pagination"
							@current-change="get_page"
							background
							layout="prev, pager, next"
							:total="list_count"
							:page-size="perPage"
							:current-page.sync="currentPage"
						></el-pagination>
					</el-col>
				</el-row>
			</div>
			<div v-if="show_list_action_page == '2'">
				<el-row style="margin-top: -10px; margin-bottom: 10px">
					<el-col :span="1">
						<img
							@click="open_submit_confirmation_popup()"
							width="35px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer; position: relative; z-index: 1"
						/>
					</el-col>
					<el-col
						style="
							margin-top: 0px;
							color: #999999;
							margin-left: -10px;
							font-size: 16px;
						"
						:span="10"
					>
						<div
							@click="open_submit_confirmation_popup()"
							style="cursor: pointer; position: relative; z-index: 1"
						>
							Back
						</div>
					</el-col>
				</el-row>
				<div
					style="font-size: 16px; font-weight: bold; text-transform: capitalize"
				>
					{{ storeObj ? storeObj.location : "" }}
					( {{ storeObj ? storeObj.name : "" }} ) - Action
				</div>
				<div style="display: flex; align-items: center">
					<div style="margin-top: 10px; font-size: 16px; width: 40%">
						<span style="font-size: 16px; font-weight: bold">Approved - </span>
						<span style="color: #d26300"
							>{{ completedCountAction }} of
							{{ tableDataActionPlan.length }}</span
						>
					</div>
					<div
						style="
							margin-left: auto;
							display: flex;
							flex-wrap: nowrap;
							margin-bottom: 10px;
						"
					>
						<el-button
							v-if="storeObj.status == 'approved'"
							icon="el-icon-download"
							@click="exportCSV()"
							class="button-class-white2"
							size="mini"
						>
							Action Report
						</el-button>
						<el-button
							v-if="storeObj.status == 'approved'"
							icon="el-icon-download"
							@click="exportPDFReport()"
							class="button-class-white2"
							size="mini"
							:loading="isPDFLoading"
						>
							Download Report
						</el-button>
					</div>
					<!-- <div style="margin-left: auto; display: flex; flex-wrap: nowrap">
						<el-button
							style="background-color: #ff0000; color: white"
							class="button-class-white2"
							v-if="
								checkRejectActionPlanCondition && storeObj.status != 'rejected'
							"
							@click="markRejectActionPlanMethod()"
						>
							Reject Action Plan
						</el-button>
						<el-button
							style="background-color: green; color: white"
							class="button-class-white2"
							v-if="checkApproveActionPlan"
							@click="markApproveActionPlanMethod()"
						>
							Close Action Plan
						</el-button>
						<el-button
							style="background-color: green; color: white"
							class="button-class-white2"
							v-if="storeObj.status == 'approved'"
							:disabled="storeObj.status == 'approved'"
						>
							Approved
						</el-button>
						
						<el-button
							v-if="submitButtonCondition"
							class="button-class2"
							style="margin-right: 10px; min-width: 150px"
							@click="submit_action(storeObj)"
						>
							{{ getSubmitText }}
						</el-button>
						<el-button
							v-if="!checkApproveAllCondition"
							:disabled="checkApproveAllCondition"
							icon="el-icon-success"
							class="button-class-white2"
							style="margin-right: 10px"
							@click="approveAllMethod()"
						>
							Approve All
						</el-button>
					</div> -->
				</div>
				<!-- 
						@selection-change="handleSelectionChange"
				 -->
				<el-card shadow="none">
					<div class="table-wrapper">
						<table v-if="tableVisible" class="custom-table">
							<thead>
								<tr>
									<th style="width: 50px">
										<el-checkbox
											@change="changeAllChecked"
											v-model="checkedAll"
										></el-checkbox>
									</th>
									<th>
										Step
										<el-popover placement="right" width="400" trigger="click">
											<el-input
												v-model="searched_step"
												size="mini"
												placeholder="Search Step"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_step">
													<el-checkbox
														v-for="(step, index) in uniqueStepNames.filter(
															(el) =>
																!searched_step ||
																el
																	.toLowerCase()
																	.includes(searched_step.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="step"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_step = [...uniqueStepNames]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_step = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_step.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>
									<th>
										Form
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_form"
												size="mini"
												placeholder="Search Form"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_form">
													<el-checkbox
														v-for="(form, index) in uniqueFormNames.filter(
															(el) =>
																!searched_form ||
																el
																	.toLowerCase()
																	.includes(searched_form.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="form"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_form = [...uniqueFormNames]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_form = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_form.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>
									<th>
										Category
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_category"
												size="mini"
												placeholder="Search Category"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_category">
													<el-checkbox
														v-for="(form, index) in uniqueCategoryNames.filter(
															(el) =>
																!searched_category ||
																el
																	.toLowerCase()
																	.includes(searched_category.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="form"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_category = [...uniqueCategoryNames]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_category = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_category.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>
									<th>
										Status
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_status"
												size="mini"
												placeholder="Search Status"
											></el-input>
											<div
												style="
													max-height: 200px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_status">
													<el-checkbox
														v-for="(
															status, index
														) in uniqueActionPlanStatus.filter(
															(el) =>
																!searched_status ||
																el
																	.toLowerCase()
																	.includes(searched_status.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="status"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div
												style="text-align: center"
												v-if="
													uniqueActionPlanStatus.filter(
														(el) =>
															!searched_status ||
															el
																.toLowerCase()
																.includes(searched_status.toLowerCase())
													).length == 0
												"
											>
												No results found
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_status = [...uniqueActionPlanStatus]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_status = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_status.length"
													src="../../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(item, key) in tableDataActionPlan
										.filter(
											(el) =>
												!selected_step.length ||
												selected_step.includes(el.form_question)
										)
										.filter(
											(el) =>
												!selected_form.length || selected_form.includes(el.form)
										)
										.filter(
											(el) =>
												!selected_category.length ||
												selected_category.includes(el.form_category)
										)
										.filter(
											(el) =>
												!selected_status.length ||
												selected_status.includes(el.status)
										)
										.filter(
											(el, index) =>
												index >= startNumberAction - 1 &&
												index < endNumberAction
										)"
									:key="key"
								>
									<td style="width: 50px">
										<el-checkbox
											@change="checkChecked(item)"
											v-model="item.checked"
											:disabled="item.status != 'completed'"
										></el-checkbox>
									</td>
									<td>
										<div
											@click="action_plan_row_click(item, key)"
											style="
												text-transform: capitalize;
												color: #d26300;
												cursor: pointer;
												word-break: break-word;
											"
										>
											<u>{{ item.form_question }}</u>
										</div>
									</td>
									<td>
										<div
											style="text-transform: capitalize; word-break: break-word"
										>
											{{ item.form }}
										</div>
									</td>
									<td>
										<div
											style="text-transform: capitalize; word-break: break-word"
										>
											{{ item.form_category }}
										</div>
									</td>
									<td>
										<el-tag
											size="small"
											style="
												border-radius: 12px;
												width: 80px;
												text-align: center;
												text-transform: capitalize;
											"
											:style="
												item.status == 'rejected' ||
												item.status == 'in_progress' ||
												item.status == 'overdue'
													? 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
													: 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
											"
											>{{
												item.status == "in_progress"
													? "In Progress"
													: item.status
											}}
										</el-tag>
										<div
											style="font-size: 10px; color: red"
											v-if="item.status == 'completed'"
										>
											Approval Pending
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</el-card>
				<el-row :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumberAction }} to {{ endNumberAction }} of
							{{ tableDataActionPlan.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPageAction"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="tableDataActionPlan.length"
							:page-size="perPageAction"
							:current-page.sync="currentPageAction"
						></el-pagination>
					</el-col>
				</el-row>
				<el-card style="margin-top: 5px" shadow="none">
					<div style="display: flex; align-items: center">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button
								style="background-color: #ff0000; color: white"
								class="button-class-white2"
								v-if="
									checkRejectActionPlanCondition &&
									storeObj.status != 'rejected'
								"
								@click="markRejectActionPlanMethod()"
							>
								Reject Action Plan
							</el-button>
							<el-button
								style="background-color: green; color: white"
								class="button-class-white2"
								v-if="checkApproveActionPlan"
								@click="markApproveActionPlanMethod()"
							>
								Close Action Plan
							</el-button>
							<el-button
								style="background-color: green; color: white"
								class="button-class-white2"
								v-if="storeObj.status == 'approved'"
								:disabled="storeObj.status == 'approved'"
							>
								Approved
							</el-button>
							<!-- 
							:disabled="disableSubmitButton()"
						 -->
							<el-button
								v-if="submitButtonCondition"
								class="button-class2"
								style="margin-right: 10px; min-width: 150px"
								@click="submit_action(storeObj)"
							>
								{{ getSubmitText }}
							</el-button>
							<!-- <el-button
						v-if="storeObj.status == 'approved'"
							icon="el-icon-download"
							class="button-class-white2"
							style="margin-right: 10px"
							@click="downloadCsvReport(storeObj)"
						>
							Project Report
						</el-button> -->
							<!-- <el-button
						v-if="storeObj.status == 'approved'"
							icon="el-icon-download"
							@click="exportCSV()"
							class="button-class-white2"
						>
							Action Report
						</el-button> -->
							<el-button
								v-if="!checkApproveAllCondition"
								:disabled="checkApproveAllCondition"
								icon="el-icon-success"
								class="button-class-white2"
								style="margin-right: 10px"
								@click="approveAllMethod()"
							>
								Approve All
							</el-button>
						</div>
					</div>
				</el-card>
			</div>
			<div v-if="show_list_action_page == '3'">
				<el-row style="margin-top: -10px; margin-bottom: 10px">
					<el-col :span="1">
						<img
							@click="show_page_2()"
							width="35px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer; position: relative; z-index: 1"
						/>
					</el-col>
					<el-col
						style="
							margin-top: 0px;
							color: #999999;
							margin-left: -10px;
							font-size: 16px;
						"
						:span="10"
					>
						<div
							@click="show_page_2()"
							style="cursor: pointer; position: relative; z-index: 1"
						>
							Back
						</div>
					</el-col>
				</el-row>
				<div style="margin-left: 3.5%">
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 10px">
						{{ storeObjSubmit.form_question }}
					</div>
				</div>
				<div style="height: 65vh; overflow-y: auto">
					<el-card shadow="none">
						<div style="margin-left: 2%">
							<div style="display: flex; width: 100%">
								<div style="width: 14%"><strong>Created On</strong></div>
								<div>
									{{
										page_3_response.reported_on
											? moment
													.utc(page_3_response.reported_on)
													.local()
													.format("Do MMM YY, HH:mm:ss")
											: "-"
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Category</strong></div>
								<div>
									{{
										page_3_response.form_category_info
											? page_3_response.form_category_info.name
											: ""
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Form</strong></div>
								<div>
									{{
										page_3_response.form_info
											? page_3_response.form_info.name
											: ""
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>User Input</strong></div>
								<div>{{ get_page3_userInput_values(page_3_response) }}</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Comment</strong></div>
								<div>
									{{
										page_3_response.form_question_execution_info &&
										page_3_response.form_question_execution_info.comment
											? page_3_response.form_question_execution_info.comment
											: "-"
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Attachment(s)</strong></div>
								<div
									style="color: #d26300; margin-right: 20px; cursor: pointer"
									v-for="(
										item, idx
									) in page_3_response.form_question_execution_info &&
									page_3_response.form_question_execution_info
										.form_question_execution_attachments
										? page_3_response.form_question_execution_info
												.form_question_execution_attachments
										: []"
									:key="idx"
								>
									<u
										@click="
											get_image(
												page_3_response.form_question_execution_info
													.form_question_execution_attachments,
												'1',
												idx
											)
										"
									>
										{{
											item && item.file_name
												? item.file_name.length >= 20
													? `${item.file_name.substring(0, 15)}...`
													: item.file_name
												: ""
										}}
									</u>
								</div>
							</div>
						</div>
					</el-card>
					<el-card style="margin-top: 10px" shadow="none">
						<div style="margin-left: 2%">
							<div style="font-size: 16px; font-weight: bold">
								Action raised
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Comment</strong></div>
								<div>
									{{
										page_3_response.issue_dscription != null
											? page_3_response.issue_dscription
											: "-"
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Attachment(s)</strong></div>
								<div
									style="color: #d26300; margin-right: 20px; cursor: pointer"
									v-for="(item, idx) in page_3_response.issue_attachments_info
										? page_3_response.issue_attachments_info
										: []"
									:key="idx"
								>
									<u
										@click="
											get_image(
												page_3_response.issue_attachments_info,
												'2',
												idx
											)
										"
									>
										{{
											item && item.file_name
												? item.file_name.length >= 20
													? `${item.file_name.substring(0, 15)}...`
													: item.file_name
												: ""
										}}</u
									>
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Due Date</strong></div>
								<div>
									{{
										page_3_response.due_date
											? moment(page_3_response.due_date).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</div>
						</div>
					</el-card>
					<el-card
						v-if="storeObj.status != 'submitted'"
						style="margin-top: 10px"
						shadow="none"
					>
						<div style="margin-left: 2%">
							<div style="font-size: 16px; font-weight: bold">
								Action Response
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Action Taken</strong></div>
								<div style="width: 50%">
									<el-input
										type="textarea"
										v-model="page_3_response.resolved_description"
										placeholder="describe the action taken "
										class="input-class"
										style="text-transform: capitalize"
										:rows="3"
										v-validate="'required'"
										name="dscribe the action taken"
										:disabled="disableCondition"
									/>
									<p>
										<span
											:v-show="errors.has(`dscribe the action taken`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`dscribe the action taken`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%">
									<strong
										>Attachment(s)
										<span
											v-if="page_3_response.attachment_mandatory"
											style="color: red"
											>*</span
										></strong
									>
								</div>
								<div style="width: 50%">
									<el-row>
										<el-col :span="10">
											<el-button
												class="button-class-white"
												icon="el-icon-upload"
												@click="$refs.fileUploadSelector.click()"
												:disabled="disableCondition"
											>
												Upload
											</el-button>
											<div
												style="font-size: 12px; margin-top: 5px; color: #d26300"
											>
												Supported media : JPG, JPEG, PNG, and PDF
											</div>
											<input
												type="file"
												ref="fileUploadSelector"
												id="fileInput"
												accept=".jpeg, .jpg, .png, .pdf, .gif, .csv, .webp, .vnd.openxmlformats-officedocument.spreadsheetml.sheet, .vnd.ms-excel, .mp4, .mov, .wmv, .avi, .avchd, .flv, .f4v, .swf, .mkv, .webm, .mpg, .mp2, .mpeg, .mpe, .mpv"
												@change="upload_file_handler"
												style="display: none"
												multiple
											/>
										</el-col>
										<el-col :span="8">
											<ul
												style="font-size: 12px; list-style: none"
												v-for="(item, idx) in fileURLArray"
												:key="idx"
											>
												<li style="margin-bottom: 5px">
													<span>
														<img
															width="12px"
															src="../../../../assets/icons/Document.png"
															style="cursor: pointer; margin-left: 5px"
														/>
													</span>
													<span
														style="margin-left: 5px; cursor: pointer"
														@click="preview_license(item, idx)"
														>{{
															item.fileDetails && item.fileDetails.name
																? item.fileDetails.name.length >= 20
																	? `${item.fileDetails.name.substring(
																			0,
																			15
																	  )}...`
																	: item.fileDetails.name
																: ""
														}}
													</span>
													<span
														><img
															v-if="!disableCondition"
															@click="delete_file_list(item)"
															width="12px"
															src="../../../../assets/icons/close.png"
															style="cursor: pointer; margin-left: 5px"
															class="mt-1"
													/></span>
												</li>
											</ul>
										</el-col>
									</el-row>
								</div>
							</div>
						</div>
					</el-card>
					<el-card
						v-if="
							storeObj.status == 'submitted' || storeObj.status == 'approved'
						"
						style="margin-top: 10px"
						shadow="none"
					>
						<div style="margin-left: 2%">
							<div style="font-size: 16px; font-weight: bold">
								Action Response
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Submitted On</strong></div>
								<div>
									{{
										page_3_response.completed_on
											? moment
													.utc(page_3_response.completed_on)
													.local()
													.format("Do MMM YYYY, HH:mm")
											: "-"
									}}
								</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Action Taken</strong></div>
								<div>{{ page_3_response.resolved_description }}</div>
							</div>
							<div style="display: flex; margin-top: 10px; width: 100%">
								<div style="width: 14%"><strong>Attachment(s)</strong></div>

								<div
									v-if="
										page_3_response.resolved_attachments_info &&
										page_3_response.resolved_attachments_info.length > 0
									"
								>
									<div
										v-for="(
											item, idx
										) in page_3_response.resolved_attachments_info"
										:key="idx"
										style="color: #d26300; margin-right: 10px"
									>
										<div
											@click="
												get_image(
													page_3_response.resolved_attachments_info,
													'3',
													idx
												)
											"
										>
											<u>
												{{ item.file_name }}
											</u>
										</div>
									</div>
								</div>

								<div v-else>-</div>
							</div>
						</div>
					</el-card>
				</div>
				<el-card style="margin-top: 10px" shadow="none">
					<div style="display: flex; margin-top: 20px">
						<div style="margin-left: auto">
							<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
								<el-button
									@click="show_page_2()"
									text
									class="button-class-white2"
								>
									Cancel
								</el-button>
								<el-button
									@click="go_back_page_3()"
									text
									icon="el-icon-caret-left"
									class="button-class-white2"
									:disabled="currentIndex == 0"
								>
									Previous
								</el-button>
								<el-button
									v-if="checkSaveCondition"
									@click="update_actions(null)"
									class="button-class-white2"
								>
									Save & Exit
								</el-button>
								<el-button
									v-if="checkSaveCondition"
									:disabled="tableDataActionPlan.length - 1 == currentIndex"
									class="button-class-white2"
									@click="update_actions('next')"
									icon="el-icon-caret-right"
								>
									Next
								</el-button>
								<!-- <el-button
									v-if="checkRejectedCondition"
									class="button-class2"
									style="background-color: red; width: 200px"
									:disabled="true"
								>
									Rejected
								</el-button> -->
								<!-- <el-button
									v-if="checkCompletedCondition()"
									class="button-class2"
									style="background-color: green"
									:disabled="true"
								>
									Completed
								</el-button> -->
								<el-button
									v-if="checkApproveAndRejectCondition"
									@click="approveRejectActions('reject')"
									class="button-class2"
									style="background-color: #ff0000; width: 200px"
								>
									Reject
								</el-button>
								<el-button
									v-if="checkApproveAndRejectCondition"
									class="button-class2"
									style="background-color: #41be62; width: 200px"
									@click="approveRejectActions('approve')"
								>
									{{
										currentIndex != tableDataActionPlan.length
											? "Approve & Next"
											: "Approve"
									}}
								</el-button>
								<!-- <el-button
									v-if="page_3_response.status == 'approved'"
									class="button-class2"
									style="background-color: #41be62; width: 200px"
									:disabled="true"
								>
									Approved
								</el-button> -->
								<el-button
									v-if="!checkApproveAndRejectCondition && !checkSaveCondition"
									@click="go_next_page_3()"
									text
									icon="el-icon-caret-right"
									class="button-class-white2"
									:disabled="tableDataActionPlan.length - 1 == currentIndex"
								>
									Next
								</el-button>
							</div>
						</div>
					</div>
				</el-card>

				<!-- <div style="display: flex; margin-top: 30px">
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<div
								v-if="
									page_3_response.status == 'rejected' &&
									storeObj.status == 'rejected' &&
									this.storeObj.actions_to_be_completed_by.find(
										(el) => el === this.getUserDetails.designation
									)
								"
							>
								<el-button class="button-class-white2" @click="show_page_2()">
									Back
								</el-button>
								<el-button
									@click="update_actions(null)"
									class="button-class2"
									style="width: 200px"
								>
									Save
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="getApprovalByCondition"
					style="display: flex; margin-top: 20px"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
							<el-button
								@click="approveRejectActions('reject')"
								class="button-class2"
								style="background-color: #ff0000; width: 200px"
							>
								Reject
							</el-button>
							<el-button
								class="button-class2"
								style="background-color: #41be62; width: 200px"
								@click="approveRejectActions('approve')"
							>
								Approve
							</el-button>
						</div>
					</div>
				</div> -->
				<!-- {{ page_3_response.status }}--{{ storeObj.status }} -->
				<!-- <div
					v-if="getApprovalByCondition1"
					style="display: flex; margin-top: 20px"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
						</div>
					</div>
				</div>
				<div
					v-if="getApprovalByCondition2"
					style="display: flex; margin-top: 20px"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
						</div>
					</div>
				</div>
				<div
					v-if="
						!(
							page_3_response.status == 'rejected' ||
							page_3_response.status == 'in_progress' ||
							(storeObj.status == 'rejected' &&
								this.storeObj.actions_to_be_completed_by.find(
									(el) => el === this.getUserDetails.designation
								))
						)
					"
					style="display: flex; margin-top: 20px"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
							<el-button
								class="button-class2"
								style="background-color: #41be62; width: 200px"
								:disabled="true"
							>
								Approved
							</el-button>
						</div>
					</div>
				</div>
				<div
					style="display: flex"
					v-if="
						!(
							page_3_response.status == 'rejected' ||
							(storeObj.status == 'rejected' &&
								this.storeObj.actions_to_be_completed_by.find(
									(el) => el === this.getUserDetails.designation
								))
						) == false &&
						!(
							page_3_response.status == 'approved' ||
							(storeObj.status == 'rejected' &&
								this.storeObj.actions_to_be_completed_by.find(
									(el) => el === this.getUserDetails.designation
								))
						) == false &&
						!(
							page_3_response.status == 'rejected' &&
							storeObj.status == 'rejected' &&
							this.storeObj.actions_to_be_completed_by.find(
								(el) => el === this.getUserDetails.designation
							)
						) &&
						!page_3_response.status == 'completed'
					"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
							<el-button
								class="button-class2"
								style="background-color: #41be62; width: 200px"
								:disabled="true"
							>
								Approved
							</el-button>
						</div>
					</div>
				</div>
				<div
					style="display: flex"
					v-if="
						!(
							page_3_response.status == 'rejected' ||
							(storeObj.status == 'rejected' &&
								this.storeObj.actions_to_be_completed_by.find(
									(el) => el === this.getUserDetails.designation
								))
						) == false &&
						!(
							page_3_response.status == 'approved' ||
							(storeObj.status == 'rejected' &&
								this.storeObj.actions_to_be_completed_by.find(
									(el) => el === this.getUserDetails.designation
								))
						) == false &&
						!(
							page_3_response.status == 'rejected' &&
							storeObj.status == 'rejected' &&
							this.storeObj.actions_to_be_completed_by.find(
								(el) => el === this.getUserDetails.designation
							)
						) &&
						!(
							page_3_response.status == 'completed' &&
							storeObj.status == 'rejected' &&
							this.storeObj.actions_to_be_completed_by.find(
								(el) => el === this.getUserDetails.designation
							)
						)
					"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
							<el-button
								class="button-class2"
								style="background-color: #41be62; width: 200px"
								:disabled="true"
							>
								Approved
							</el-button>
						</div>
					</div>
				</div>
				<div
					v-if="
						!(
							page_3_response.status == 'approved' ||
							page_3_response.status == 'in_progress' ||
							(storeObj.status == 'rejected' && storeObj.status == 'rejected'
								? this.storeObj.actions_to_be_completed_by.find(
										(el) => el === this.getUserDetails.designation
								  )
								: this.storeObj.actions_approval_by.find(
										(el) => el === this.getUserDetails.designation
								  ))
						)
					"
					style="display: flex; margin-top: 20px"
				>
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_2()">
								Back
							</el-button>
							<el-button
								class="button-class2"
								style="background-color: #ff0000; width: 200px"
								:disabled="true"
							>
								Rejected1
							</el-button>
						</div>
					</div>
				</div> -->
			</div>
			<div v-if="show_list_action_page == '5'">
				<el-row style="margin-top: -10px; margin-bottom: 10px">
					<el-col :span="1">
						<img
							@click="show_page_4()"
							width="35px"
							src="../../../../assets/icons/Back Arrow.png"
							style="cursor: pointer; position: relative; z-index: 1"
						/>
					</el-col>
					<el-col
						style="
							margin-top: 0px;
							color: #999999;
							margin-left: -10px;
							font-size: 16px;
						"
						:span="10"
					>
						<div
							@click="show_page_4()"
							style="cursor: pointer; position: relative; z-index: 1"
						>
							Back
						</div>
					</el-col>
				</el-row>
				<el-card shadow="none" style="height: 70vh">
					<div style="margin-left: 30px">
						<div><b>Reason for Rejection</b></div>
						<div>
							<textarea
								rows="4"
								type="text"
								v-model="reason"
								placeholder="Describe Reason for Rejection"
								class="input-class-dialog-textarea mt-2"
								style="width: 50%"
								v-validate="'required'"
								name="reason"
							/>
							<p>
								<span
									:v-show="errors.has(`reason`)"
									class="text-red-dark text-xs"
								>
									{{ errors.first(`reason`) ? "This field is required" : "" }}
								</span>
							</p>
						</div>
					</div>
				</el-card>
				<div style="display: flex; margin-top: 30px">
					<div style="margin-left: auto">
						<div style="margin-left: auto; display: flex; flex-wrap: nowrap">
							<el-button class="button-class-white2" @click="show_page_4()">
								Back
							</el-button>
							<el-button
								@click="approveRejectAPI('rejected')"
								class="button-class2"
								style="width: 200px; background-color: #ff0000"
							>
								{{
									currentIndex != tableDataActionPlan.length
										? "Reject & Next"
										: "Approve"
								}}
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="previewLicenseDialog">
			<el-row style="margin-top: -10px; margin-bottom: 10px">
				<el-col :span="1">
					<img
						@click="show_page_3()"
						width="35px"
						src="../../../../assets/icons/Back Arrow.png"
						style="cursor: pointer; position: relative; z-index: 1"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						@click="show_page_3()"
						style="cursor: pointer; position: relative; z-index: 1"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<PreviewLicenses
				:previewLicenseDialog="previewLicenseDialog"
				@close="previewLicenseDialog = false"
				:imgObject="imgObject"
				:fileURLArray="fileURLArray"
				:fileURLArray1="fileURLArray1"
				:clicked_val="clicked_val"
				:fileURLArray2="fileURLArray2"
				:fileURLArray3="fileURLArray3"
				:currentItemIndex="currentItemIndex"
				@update:currentItemIndex="updateCurrentItemIndex"
			/>
		</div>
		<SubmitConfirmation
			:submitDialog="submitDialog"
			:confirmationTitle="confirmationTitle"
			:confirmationText="confirmationText"
			@cancel="call_cancel_btn"
			@success="call_submit_confirmation_api"
			:loading="loading"
			:confirmationType="confirmationType"
			:actionObject="actionObject"
			:alertType="alertType"
		/>
		<ActionPdfReport
			:data="five_k_report_data.data"
			:meta="five_k_report_data.meta"
		/>
	</div>
</template>

<script>
import PreviewLicenses from "../../LicenseManagement/PreviewLicenses.vue";
import formBuilderServices from "../../../../services/formBuilderServices";
import { mapState, mapActions } from "vuex";
import TaskSkeletonLoader from "../../labourPlaninig/tasks/taskSkeletonLoader.vue";
var moment = require("moment");
import exportFromJSON from "export-from-json";
import SubmitConfirmation from "./SubmitConfirmation.vue";
import { EventBus } from "../../../../eventBus";
import ActionPdfReport from "@/components/UI/pdf/ActionPdfReport.vue";

export default {
	props: {
		show_list_action_page: String,
		storeObj: Object,
		storeObjSubmit: Object,
		getUserDetails: Object,
	},
	components: {
		PreviewLicenses,
		TaskSkeletonLoader,
		SubmitConfirmation,
		ActionPdfReport,
	},
	data: () => ({
		actionObject: {},
		confirmationTitle: "",
		submitDialog: false,
		confirmationText: "",
		loading: false,
		confirmationType: "",
		moment: moment,
		isDomLoading: false,
		search: "",
		location: [],
		locationItems: [],
		perPageAction: 10,
		currentPageAction: 1,
		perPage: 10,
		currentPage: 1,
		pagination: {
			currentPage: 1,
		},
		tableData: [],
		tableDataActionPlan: [],
		last_completed_on_order: "",
		completedOn_order: "",
		last_grade_order: "",
		selected_project: [],
		searched_project: "",
		selectedLocation: [],
		searchedLocation: "",
		searched_designation: "",
		selected_designation: [],
		selected_grade: [],
		searched_grade: "",
		searched_status: "",
		selected_status: [],
		searched_step: "",
		selected_step: [],
		selected_form: [],
		searched_form: "",
		searched_category: "",
		selected_category: [],
		dscription: "",
		fileURLArray: [],
		imgObject: {},
		previewLicenseDialog: false,
		page_3_response: {},
		fileURLArray1: [],
		clicked_val: null,
		fileURLArray2: [],
		uploadedAttachments: [],
		fileURLArray3: [],
		completedCountAction: 0,
		all_designations: [],
		all_grades: [],
		all_projects: [],
		all_status: [],
		all_submitted_by: [],
		list_count: 0,
		debounceTimer: null,
		currentIndex: null,
		alertType: null,
		projectsTasksItems: [],
		projectsTasks: "",
		actionSummaryData: {},
		all_locations: [],
		dueDate_order: "",
		reason: "",
		selectedRows: [],
		tableVisible: false,
		AllRowsSelected: false,
		checkedAll: false,
		selectedLocationType: "location",
		allLocations: [],
		dates: [],
		datesItems: [
			{ name: "Month To Date", id: "month_to_date" },
			{ name: "Week To Date", id: "week_to_date" },
			{ name: "Quarter To Date", id: "quarter_to_date" },
			{ name: "Year To Date", id: "year_to_date" },
			{ name: "Last Month", id: "last_month" },
			{ name: "Last Quarter", id: "last_quarter" },
			{ name: "Month On Month", id: "month_on_month" },
			{ name: "Quarter On Quarter", id: "quarter_on_quarter" },
			{ name: "Custom Dates", id: "custom_date" },
		],
		pickerOptions: {
			firstDayOfWeek: 1,
			shortcuts: [
				{
					text: "Month To Date",
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setDate(1);
						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Last 7 Days",
					onClick(picker) {
						const end = new Date(); // Current date and time
						const start = new Date(); // Current date and time
						start.setDate(start.getDate() - 6); // Set the start date to 6 days ago (7 days including today)
						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Week To Date",
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						const firstDayOfWeek = 0;
						const diff = start.getDay() - firstDayOfWeek;
						start.setDate(start.getDate() - diff);
						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Quarter To Date",
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						const currentMonth = start.getMonth(); // Get the current month (0-11)
						let quarterStartMonth;
						if (currentMonth >= 0 && currentMonth <= 2) {
							quarterStartMonth = 0; // January
						} else if (currentMonth >= 3 && currentMonth <= 5) {
							quarterStartMonth = 3; // April
						} else if (currentMonth >= 6 && currentMonth <= 8) {
							quarterStartMonth = 6; // July
						} else {
							quarterStartMonth = 9; // October
						}
						start.setMonth(quarterStartMonth);
						start.setDate(1);

						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Year To Date",
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(0);
						start.setDate(1);
						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Last Week",
					onClick(picker) {
						const today = new Date();
						const end = new Date(today.getTime() - today.getDay() * 86400000); // Calculate last Sunday
						const start = new Date(end.getTime() - 6 * 86400000); // Calculate Monday of last week

						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Last Month",
					onClick(picker) {
						const end = new Date(); // Current date and time
						const start = new Date(); // Current date and time

						// Set end date to the last day of the previous month
						end.setMonth(end.getMonth(), 0); // Set to last day of previous month

						// Set start date to the first day of the previous month
						start.setMonth(start.getMonth() - 1); // Move one month back
						start.setDate(1); // Set the date to 1st of the month

						picker.$emit("pick", [start, end]);
					},
				},
				{
					text: "Last Quarter",
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
					},
				},
				// {
				// 	text: "Month On Month (MOM)",
				// 	onClick: (picker) => {
				// 		this.onClickHandler(picker);
				// 	},
				// },
				// {
				// 	text: "Quarter on Quarter (QOQ)",
				// 	onClick(picker) {
				// 		// Set the type to month
				// 		// picker.$emit('pick', [null, null]); // Clear current selection to change type
				// 	},
				// },
				// {
				// 	text: "Custom Dates",
				// 	onClick(picker) {
				// 		// Set the type to month
				// 		// picker.$emit('pick', [null, null]); // Clear current selection to change type
				// 	},
				// },
			],
		},
		datePickerType: "daterange",
		five_k_report_data: {},
		isPDFLoading: false,
		currentItemIndex: 0,
	}),
	computed: {
		computedActionTableData() {
			let arr = [...this.tableData];
			return arr;
		},
		uniqueProjectNames() {
			let arr = [...new Set(this.all_projects)].flat();
			return arr;
		},
		uniqueLocationNames() {
			let arr = [...new Set(this.all_locations)].flat();
			return arr;
		},
		uniqueDesignationNames() {
			let arr = [...new Set(this.all_designations)].flat();
			return arr;
		},
		uniqueStatus() {
			let arr = [...new Set(this.all_status)].flat();
			return arr;
		},
		uniqueGradeNames() {
			let arr = [...new Set(this.all_grades)].flat();
			return arr;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(this.startNumber + this.perPage - 1, this.list_count);
			return end;
		},
		startNumberAction() {
			let start =
				this.currentPageAction * this.perPageAction - (this.perPageAction - 1);
			return start;
		},
		endNumberAction() {
			let end = Math.min(
				this.startNumberAction + this.perPageAction - 1,
				this.tableDataActionPlan.length
			);
			return end;
		},
		uniqueStepNames() {
			let arr = [
				...new Set(this.tableDataActionPlan.map((el) => el.form_question)),
			];
			return arr;
		},
		uniqueFormNames() {
			let arr = [...new Set(this.tableDataActionPlan.map((el) => el.form))];
			return arr;
		},
		uniqueCategoryNames() {
			let arr = [
				...new Set(this.tableDataActionPlan.map((el) => el.form_category)),
			];
			return arr;
		},
		uniqueActionPlanStatus() {
			let arr = [...new Set(this.tableDataActionPlan.map((el) => el.status))];
			return arr;
		},
		// getUserDetails() {
		// 	console.log(
		// 		this.$store.state.loginUserDetails,
		// 		"this.$store.state.loginUserDetails"
		// 	);
		// 	return this.$store.state.loginUserDetails;
		// },
	// 	...mapState({
	// 		getUserDetails: state => state.loginUserDetails
    // }),
		checkApproveAllCondition() {
			let completedCount = 0;
			let otherCount = 0;
			// Assuming tableDataActionPlan and storeObj are properties of your class or object
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				const status = this.tableDataActionPlan[i].status;
				if (status === "completed") {
					completedCount++;
				} else {
					otherCount++;
				}
			}
			if (
				this.storeObj.status === "submitted" &&
				this.selectedRows.length != 0 &&
				completedCount != 0 &&
				this.storeObj.actions_approval_by.find(
					(el) => el === this.getUserDetails.designation
				) !== undefined
			) {
				return false;
			} else {
				return true;
			}
		},
		getSubmitText() {
			let approvedCount = 0;
			let completedCount = 0;
			let otherCount = 0;
			// Assuming tableDataActionPlan and storeObj are properties of your class or object
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				const status = this.tableDataActionPlan[i].status;
				if (status === "completed") {
					completedCount++;
				} else if (status === "approved") {
					approvedCount++;
				} else {
					otherCount++;
				}
			}
			let text = "";
			// Determine text based on storeObj.status and counts
			switch (this.storeObj.status) {
				case "submitted":
					text = "Submitted";
					break;
				case "rejected":
					if (otherCount === 0) {
						text = "Submit";
					} else {
						text = "Rejected"; // Assuming this is the intended behavior if rejected and other items exist
					}
					break;
				case "completed":
					text = "Submit"; // Assuming this is the intended behavior if completed
					break;
				default:
					text = ""; // Handle any other statuses as needed
					break;
			}

			console.log(text, "text");
			return text;
		},
		disableCondition() {
			const { getUserDetails, storeObj, page_3_response } = this;

			const isUserInActionsApprovalBy = storeObj.actions_approval_by.includes(
				getUserDetails.designation
			);
			const isUserInActionsToBeCompletedBy =
				storeObj.actions_to_be_completed_by.includes(
					getUserDetails.designation
				);
			const isUserNotInActionsToBeCompletedBy =
				storeObj.actions_to_be_completed_by.every(
					(el) => el !== getUserDetails.designation
				);

			return (
				(storeObj.status === "open" &&
					page_3_response.status === "in_progress" &&
					isUserInActionsApprovalBy) ||
				page_3_response.status === "completed" ||
				(storeObj.status === "rejected" &&
					page_3_response.status === "rejected" &&
					isUserNotInActionsToBeCompletedBy) ||
				page_3_response.status === "approved" ||
				(storeObj.status === "overdue" && isUserInActionsToBeCompletedBy) ||
				(!isUserInActionsApprovalBy && !isUserInActionsToBeCompletedBy) ||
				(storeObj.status === "open" && isUserInActionsApprovalBy)
			);
		},
		submitButtonCondition() {
			if (this.storeObj.status == "submitted") {
				console.log("1");
				return false;
			}
			if (this.getSubmitText == "") {
				return false;
			}
			let currentDate = new Date();
			let checkDate = new Date(this.storeObj.due_date);

			// Check the date condition first
			if (checkDate < currentDate) {
				if (
					this.storeObj.actions_approval_by.includes(
						this.getUserDetails.designation
					)
				) {
					return true;
				}
			} else {
				let completedCount = 0;
				let otherCount = 0;
				// Assuming tableDataActionPlan and storeObj are properties of your class or object
				for (let i = 0; i < this.tableDataActionPlan.length; i++) {
					const status = this.tableDataActionPlan[i].status;
					if (status === "completed") {
						completedCount++;
					} else {
						otherCount++;
					}
				}

				if (
					this.storeObj.status == "completed" &&
					completedCount == this.tableDataActionPlan.length &&
					this.storeObj.actions_to_be_completed_by.find(
						(el) => el === this.getUserDetails.designation
					)
				) {
					console.log("hheerre");
					return true;
				}
			}

			let approvedCount1 = 0;
			let completedCount1 = 0;
			let otherCount1 = 0;
			// Assuming tableDataActionPlan and storeObj are properties of your class or object
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				const status = this.tableDataActionPlan[i].status;
				if (status === "completed") {
					completedCount1++;
				}
				if (status === "approved") {
					approvedCount1++;
				} else {
					otherCount1++;
				}
			}

			if (
				this.storeObj.status == "rejected" &&
				completedCount1 + approvedCount1 == this.tableDataActionPlan.length &&
				this.storeObj.actions_to_be_completed_by.find(
					(el) => el === this.getUserDetails.designation
				)
			) {
				return true;
			}

			return false;
		},
		checkRejectedCondition() {
			const { getUserDetails, storeObj, page_3_response } = this;
			console.log(getUserDetails, storeObj, "getUserDetails and storeObj");

			if (
				storeObj &&
				page_3_response &&
				getUserDetails &&
				storeObj.status === "rejected" &&
				page_3_response.status === "rejected" &&
				Array.isArray(storeObj.actions_to_be_completed_by)
			) {
				return storeObj.actions_to_be_completed_by.every(
					(el) => el !== getUserDetails.designation
				);
			}
			return false;
		},
		getApprovalByCondition() {
			console.log("this.page_3_response", this.page_3_response);
			if (this.page_3_response.status == "approved") {
				return false;
			}
			if (
				((this.storeObj.status == "submitted" ||
					this.storeObj.status == "rejected") &&
				this.page_3_response.status == "completed" &&
				this.getUserDetails.designation &&
				this.storeObj.status == "rejected"
					? this.storeObj.actions_to_be_completed_by.find(
							(el) => el === this.getUserDetails.designation
					  )
					: this.storeObj.actions_approval_by.find(
							(el) => el === this.getUserDetails.designation
					  )) ||
				this.getUserDetails.access_level == "admin"
			) {
				return true;
			} else {
				return false;
			}
			// if (this.page_3_response.status == "approved") {
			// 	return true;
			// }
		},
		getApprovalByCondition2() {
			if (
				!((this.storeObj.status == "submitted" ||
					this.storeObj.status == "rejected") &&
				this.page_3_response.status == "completed" &&
				this.getUserDetails.designation &&
				this.storeObj.status == "rejected"
					? this.storeObj.actions_to_be_completed_by.find(
							(el) => el === this.getUserDetails.designation
					  )
					: this.storeObj.actions_approval_by.find(
							(el) => el === this.getUserDetails.designation
					  )) ||
				this.getUserDetails.access_level == "admin"
			) {
				return true;
			}
		},
		getApprovalByCondition1() {
			console.log("this.page_3_response", this.page_3_response);
			if (this.page_3_response.status == "approved") {
				return false;
			}
			if (
				((this.storeObj.status == "submitted" ||
					this.storeObj.status == "rejected") &&
					this.page_3_response.status == "completed" &&
					this.storeObj.actions_approval_by.find(
						(el) => el !== this.getUserDetails.designation
					)) ||
				this.getUserDetails.access_level == "admin"
			) {
				return true;
			} else {
				return false;
			}
			// if (this.page_3_response.status == "approved") {
			// 	return true;
			// }
		},
		checkRejectActionPlanCondition() {
			let rejectCount = 0;
			let ApproveCount = 0;
			let OtherCount = 0;
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				if (this.tableDataActionPlan[i].status == "rejected") {
					rejectCount += 1;
				} else if (this.tableDataActionPlan[i].status == "approved") {
					ApproveCount += 1;
				} else {
					OtherCount += 1;
				}
			}
			const allRejected = OtherCount == 0 && rejectCount != 0;
			const userHasAccess =
				this.storeObj.actions_approval_by.find(
					(el) => el === this.getUserDetails.designation
				) || this.getUserDetails.access_level == "admin";

			return allRejected && userHasAccess;
		},
		checkApproveActionPlan() {
			let ApproveCount = 0;
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				if (this.tableDataActionPlan[i].status == "approved") {
					ApproveCount += 1;
				}
			}
			if (
				ApproveCount == this.tableDataActionPlan.length &&
				this.storeObj.actions_approval_by.find(
					(el) => el === this.getUserDetails.designation
				) &&
				this.storeObj.status == "submitted"
			) {
				return true;
			}
		},
		checkApproveAndRejectCondition() {
			const { getUserDetails, storeObj, page_3_response } = this;
			const isUserInActionsApprovalBy = storeObj.actions_approval_by.includes(
				getUserDetails.designation
			);

			// Check both conditions in a single block
			if (
				(page_3_response.status === "completed" && isUserInActionsApprovalBy) ||
				(storeObj.status === "submitted" &&
					page_3_response.status === "completed" &&
					isUserInActionsApprovalBy)
			) {
				return true;
			}

			return false;
		},
		checkSaveCondition() {
			const { getUserDetails, storeObj, page_3_response } = this;

			const isUserInActionsToBeCompletedBy =
				storeObj.actions_to_be_completed_by.includes(
					getUserDetails.designation
				);
			const isUserInActionsApprovalBy = storeObj.actions_approval_by.includes(
				getUserDetails.designation
			);

			return (
				(page_3_response.status === "in_progress" &&
					storeObj.status === "open" &&
					isUserInActionsToBeCompletedBy) ||
				(page_3_response.status === "rejected" &&
					storeObj.status === "rejected" &&
					isUserInActionsToBeCompletedBy) ||
				(page_3_response.status === "overdue" &&
					storeObj.status === "overdue" &&
					isUserInActionsApprovalBy) ||
				(storeObj.status === "open" &&
					page_3_response.status != "approved" &&
					page_3_response.status != "completed" &&
					isUserInActionsToBeCompletedBy)
			);
		},
		checkNextCondition() {
			// const { getUserDetails, storeObj, page_3_response } = this;
			// const isUserInActionsApprovalBy = storeObj.actions_approval_by.includes(
			// 	getUserDetails.designation
			// );
			// const isUserInActionsToBeCompletedBy =
			// 	storeObj.actions_to_be_completed_by.includes(
			// 		getUserDetails.designation
			// 	);
			// // Check conditions
			// if (page_3_response.status === "completed" && isUserInActionsApprovalBy) {
			// 	return true;
			// }

			// if (
			// 	storeObj.status === "submitted" &&
			// 	page_3_response.status === "completed" &&
			// 	isUserInActionsApprovalBy
			// ) {
			// 	return true;
			// }

			// if (
			// 	page_3_response.status === "in_progress" &&
			// 	storeObj.status === "open" &&
			// 	isUserInActionsToBeCompletedBy
			// ) {
			// 	return true;
			// }

			// if (
			// 	page_3_response.status === "rejected" &&
			// 	storeObj.status === "rejected" &&
			// 	isUserInActionsToBeCompletedBy
			// ) {
			// 	return true;
			// }

			// if (
			// 	page_3_response.status === "overdue" &&
			// 	storeObj.status === "overdue" &&
			// 	isUserInActionsApprovalBy
			// ) {
			// 	return true;
			// }

			// return false;
			return true;
		},
		isAllSelected() {
			return this.selectedRows.length === this.tableDataActionPlan.length;
		},
	},
	async mounted() {
		const end = new Date();
		const start = new Date();
		start.setDate(1);
		this.dates = [start, end];
		this.tableVisible = false;
		this.list_all_locations();
		this.$nextTick(() => {
			this.tableVisible = true;
		});
		EventBus.$on("pdf-downloaded-successfully", () => {
			this.isPDFLoading = false;
			this.removeDownloadingReportCountAction();
		});
	},
	watch: {
		storeObjSubmit: {
			handler: function (val) {
				console.log(val); // Log the updated object
				this.fileURLArray = [];
				this.list_actions_page3(); // Call the storeObjSubmit method with the updated object
			},
			deep: true, // Enable deep watching
		},
		show_list_action_page(val) {
			if (val == 1) {
				this.listCountries();
				this.list_all_filters();
				this.list_actions_page1(
					this.currentPage,
					this.perPage,
					this.selected_project,
					this.selectedLocation,
					this.selected_designation,
					this.selected_grade,
					this.selected_status,
					this.search
				);
			}
			if (val == 2) {
				this.list_actions_page2();
				this.$forceUpdate();
			}
			if (val == 3) {
				this.$validator.reset();
				this.fileURLArray = [];
				this.list_actions_page3();
			}
			if (val == 4) {
				this.list_actions_page1(
					this.currentPage,
					this.perPage,
					this.selected_project,
					this.selectedLocation,
					this.selected_designation,
					this.selected_grade,
					this.selected_status,
					this.search,
					"refresh"
				);
				console.log(this.storeObj, "stpop");
			}
		},
		perPage(newValue) {
			this.list_actions_page1(
				(this.currentPage = 1),
				newValue,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		selected_project(val) {
			this.list_actions_page1(
				1,
				this.perPage,
				val,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		selectedLocation(val) {
			this.list_actions_page1(
				1,
				this.perPage,
				this.selected_project,
				val,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		selected_designation(val) {
			this.list_actions_page1(
				1,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				val,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		selected_grade(val) {
			this.list_actions_page1(
				1,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				val,
				this.selected_status,
				this.search
			);
		},
		selected_status(val) {
			this.list_actions_page1(
				1,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				val,
				this.search
			);
		},
		last_completed_on_order() {
			this.list_actions_page1(
				this.currentPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		completedOn_order() {
			this.list_actions_page1(
				this.currentPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		dueDate_order() {
			this.list_actions_page1(
				this.currentPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		selectedLocationType() {
			this.listSummaryData();
			this.list_all_filters();
			this.list_actions_page1(
				this.currentPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		// 	checkChecked(item){
		// 	console.log(item.checked,'item.checked')
		// 	if(item.checked) {
		// 		this.$set(item, "checked", true);
		// 	}else{
		// 		this.$set(item, "checked", false);
		// 	}
		// 	console.log(item.checked,'item.checked22')
		// },
		async listCountries() {
			try {
				const res = await formBuilderServices.getCountryList();
				this.locationItems = JSON.parse(res.data).results;
				this.locationItems.forEach((el) => {
					el.label = el.name;
					el.value = el.id;
					if (el.children && el.children.length != 0) {
						el.regions = el.children;
						el.regions.forEach((elR) => {
							elR.label = elR.name;
							elR.value = elR.id;
							if (elR.children.length != 0) {
								elR.subregions = elR.children;
								elR.subregions.forEach((elS) => {
									elS.label = elS.name;
									elS.value = elS.id;
									if (elS.children.length != 0) {
										elS.outlet = elS.children;
										elS.outlet.forEach((elO) => {
											elO.label = elO.name;
											elO.value = elO.id;
										});
									}
								});
							}
						});
					} else {
						el.children = el.regions;
						el.children.forEach((elR) => {
							elR.label = elR.name;
							elR.value = elR.id;
							if (elR.subregions.length != 0) {
								elR.children = elR.subregions;
								elR.children.forEach((elS) => {
									elS.label = elS.name;
									elS.value = elS.id;
									if (elS.outlets.length != 0) {
										elS.children = elS.outlets;
										elS.children.forEach((elO) => {
											elO.label = elO.name;
											elO.value = elO.id;
										});
									}
								});
							}
						});
					}
				});
				console.log(this.locationItems, "this.locationItems");
			} catch (e) {
				console.log(e, "e");
			}
			// formBuilderServices.getCountryList().then((res) => {

			// });
			// formBuilderServices.listAllLocations().then((res) => {
			// 	let allLocations = JSON.parse(res.data);
			// 	console.log(allLocations, "allLocations");
			// 	this.allLocations = allLocations.sort((a, b) =>
			// 		a.name < b.name ? -1 : 1
			// 	);
			// });
		},
		updateCurrentItemIndex(newIndex) {
			this.currentItemIndex = null;
			this.currentItemIndex = newIndex;
			this.$forceUpdate();
		},
		checkChecked(item) {
			this.tableVisible = false;
			console.log(item, "item.checked");
			if (!item.checked) {
				this.checkedAll = false;
				this.selectedRows = this.selectedRows.filter((row) => row !== item);
			} else {
				this.checkedAll = this.tableDataActionPlan.every((i) => i.checked);
				if (!this.selectedRows.includes(item)) {
					this.selectedRows.push(item);
				}
			}
			this.tableVisible = true;
			console.log(item.checked, "item.checked22");
			console.log(this.selectedRows, "selectedRows");
		},
		updateSelectedRows() {
			if (this.checkedAll) {
				this.selectedRows = [...this.tableDataActionPlan].filter(
					(el) => el.checked
				);
			} else {
				this.selectedRows = [];
			}
			console.log(this.selectedRows, "selectedRows after changeAllChecked");
		},
		changeAllChecked() {
			console.log(this.checkedAll, "this.checkedAll");
			// this.checkedAll = !this.checkedAll;
			for (let i = 0; i < this.tableDataActionPlan.length; i++) {
				if (this.tableDataActionPlan[i].status == "completed") {
					this.$set(this.tableDataActionPlan[i], "checked", this.checkedAll);
				}
			}
			console.log(this.checkedAll, "this.checkedAll12");
			this.updateSelectedRows();
		},
		go_back_page_3() {
			this.currentIndex = this.currentIndex - 1;
			let new_item = this.tableDataActionPlan[this.currentIndex];
			console.log(
				this.currentIndex,
				this.tableDataActionPlan.length,
				"this.tableDataActionPlanthis.tableDataActionPlan"
			);
			if (this.currentIndex != this.tableDataActionPlan.length)
				this.$emit("show_submit_page", new_item);
		},
		go_next_page_3() {
			this.currentIndex = this.currentIndex + 1;
			let new_item = this.tableDataActionPlan[this.currentIndex];
			console.log(
				this.currentIndex,
				this.tableDataActionPlan.length,
				"this.tableDataActionPlanthis.tableDataActionPlan"
			);
			if (this.currentIndex != this.tableDataActionPlan.length)
				this.$emit("show_submit_page", new_item);
		},
		approveAllMethod() {
			let params = [];
			for (let i = 0; i < this.selectedRows.length; i++) {
				params.push({
					id: this.selectedRows[i].id,
					status: "approved",
					rejection_reason: "",
				});
			}
			formBuilderServices.ApproveRejectActionFlow(params).then((res) => {
				this.selectedRows = [];
				this.$emit("recall_page_2", this.storeObj);
				this.$notify.success({
					title: "Success",
					message: `Action Approved Successfully`,
					type: "Success",
				});
				// this.$emit("recall_page_2", this.storeObj);
			});
		},
		checkCompletedCondition() {
			if (
				(this.storeObj.status == "completed" ||
					this.storeObj.status == "submitted") &&
				this.page_3_response.status == "completed" &&
				this.storeObj.actions_approval_by.find(
					(el) => el !== this.getUserDetails.designation
				) !== undefined
			) {
				return true;
			}
		},
		// checkSaveCondition() {
		// 	if (
		// 		this.page_3_response.status == "in_progress" &&
		// 		this.storeObj.status == "open" &&
		// 		this.storeObj.actions_to_be_completed_by.find(
		// 			(el) => el === this.getUserDetails.designation
		// 		) !== undefined
		// 	) {
		// 		// Condition 1: Succeeds
		// 		// Perform actions when the condition succeeds
		// 		return true;
		// 	} else if (
		// 		this.page_3_response.status == "rejected" &&
		// 		this.storeObj.status == "rejected" &&
		// 		this.storeObj.actions_to_be_completed_by.find(
		// 			(el) => el === this.getUserDetails.designation
		// 		) !== undefined
		// 	) {
		// 		// Condition 2: Check next condition
		// 		// Perform actions when condition 1 fails but condition 2 succeeds
		// 		return true;
		// 	} else if (
		// 		this.page_3_response.status == "overdue" &&
		// 		this.storeObj.status == "overdue" &&
		// 		this.storeObj.actions_approval_by.find(
		// 			(el) => el === this.getUserDetails.designation
		// 		) !== undefined
		// 	) {
		// 		// Perform actions when both conditions fail
		// 		return true;
		// 	}
		// },
		markRejectActionPlanMethod() {
			let params = {
				project_execution_id: this.storeObj.id,
			};
			formBuilderServices.markRejectActionFlow(params).then((res) => {
				this.$emit("recall_page_2", this.storeObj);
				this.$notify.success({
					title: "Success",
					message: `Action Plan Rejected Successfully`,
					type: "Success",
				});
			});
		},
		markApproveActionPlanMethod() {
			let params = {
				project_execution_id: this.storeObj.id,
			};
			formBuilderServices.markApproveActionFlow(params).then((res) => {
				// this.$emit("recall_page_2", this.storeObj);
				this.$emit("hide_view_page");
				this.$notify.success({
					title: "Success",
					message: `Action Plan Approved Successfully`,
					type: "Success",
				});
			});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChangeHeader() {
			this.tableVisible = false;
			this.AllRowsSelected = !this.AllRowsSelected;
			for (let i = 0; i < this.tableDataActionPlan; i++) {
				if (this.AllRowsSelected) {
					this.$set(this.tableDataActionPlan[i], "status", false);
				} else {
					this.$set(this.tableDataActionPlan[i], "status", true);
				}
			}
			console.log(this.tableDataActionPlan, "this.tableDataActionPlan");
			this.tableVisible = true;
			this.$forceUpdate();
		},
		handleSelectionChange(row, type = "row") {
			if (type === "header") {
				if (this.isAllSelected) {
					this.selectedRows = [];
				} else {
					this.selectedRows = [...this.tableDataActionPlan];
					for (let i = 0; i < this.selectedRows.length; i++) {
						if (this.isSelected(this.selectedRows[i])) {
							console.log("here", this.isSelected(this.selectedRows[i]));
							this.handleSelectionChange1(this.selectedRows[i], "row");
						}
					}
				}
			} else {
				if (this.isSelected(row)) {
					this.selectedRows = this.selectedRows.filter((item) => item !== row);
				} else {
					this.selectedRows.push(row);
				}
			}
			console.log("Selected Rows:", this.selectedRows);
		},
		handleSelectionChange1(row, type = "row") {
			if (type === "row") {
				if (this.isSelected(row)) {
					this.selectedRows = this.selectedRows.filter((item) => item !== row);
				} else {
					this.selectedRows.push(row);
				}
			}
			this.$forceUpdate();
			console.log("Selected Rows1111111111111111:", this.selectedRows);
		},
		isSelected(row) {
			return this.selectedRows.includes(row);
		},
		// disableSubmitButton() {
		// 	console.log(this.storeObj, this.getUserDetails, "source");
		// 	if (
		// 		this.storeObj.status === "completed" &&
		// 		this.getUserDetails.designation &&
		// this.storeObj.actions_to_be_completed_by.find(
		// 	(el) => el === this.getUserDetails.designation
		// )
		// 	) {
		// 		return false; // Do not disable the submit button
		// 	}
		// 	if (
		// 		this.storeObj.status === "rejected" &&
		// 		this.countCompletedAndApproved() === 0
		// 	) {
		// 		return false; // Do not disable the submit button
		// 	}
		// 	return true;
		// },
		// countCompletedAndApproved() {
		// 	let approvedCount = 0;
		// 	let completedCount = 0;
		// 	for (let i = 0; i < this.tableDataActionPlan.length; i++) {
		// 		const status = this.tableDataActionPlan[i].status;
		// 		if (status === "completed") {
		// 			completedCount++;
		// 		} else if (status === "approved") {
		// 			approvedCount++;
		// 		}
		// 	}
		// 	return completedCount + approvedCount;
		// },

		// submitButtonCondition() {
		// 	let currentDate = new Date();
		// 	let checkDate = new Date(this.storeObj.due_date);
		// 	// Check if the due date is in the past
		// 	const userDesignation = this.getUserDetails.designation;
		// 	const isUserResponsible =
		// 		this.storeObj.actions_to_be_completed_by.includes(userDesignation);
		// 		const isUserResponsible1 =
		// 		this.storeObj.actions_approval_by.includes(userDesignation);
		// 	if (checkDate < currentDate && isUserResponsible1) {
		// 		return true;
		// 	}
		// 	let completedCount = 0;
		// 	let approvedCount = 0;
		// 	for (let action of this.tableDataActionPlan) {
		// 		if (action.status === "completed") {
		// 			completedCount++;
		// 		} else if (action.status === "approved") {
		// 			approvedCount++;
		// 		}
		// 	}
		// 	// Check conditions for the "completed" status
		// 	if (
		// 		this.storeObj.status === "completed" &&
		// 		completedCount === this.tableDataActionPlan.length &&
		// 		isUserResponsible
		// 	) {
		// 		return true;
		// 	}
		// 	// Check conditions for the "rejected" status
		// 	if (
		// 		this.storeObj.status === "rejected" &&
		// 		completedCount + approvedCount === this.tableDataActionPlan.length &&
		// 		isUserResponsible
		// 	) {
		// 		return true;
		// 	}
		// 	return false;
		// },
		approveRejectActions(type) {
			switch (type) {
				case "reject":
					let storeObj = {};
					storeObj = this.tableData.find((obj) => obj.id === this.storeObj.id);
					console.log(storeObj, "storeObjstoreObjstoreObj");
					this.$emit("rejectReasonPage", storeObj);
					break;
				case "approve":
					this.approveRejectAPI("approved");
					break;

				default:
					break;
			}
		},
		approveRejectAPI(type) {
			if (type == "rejected") {
				this.$validator.validateAll().then((result) => {
					if (result) {
						let params = [
							{
								id: this.storeObjSubmit.id,
								status: type,
								rejection_reason: this.reason,
							},
						];
						formBuilderServices.ApproveRejectActionFlow(params).then((res) => {
							this.fileURLArray = [];
							this.$emit("recall_page_2", this.storeObj);
							this.$notify.success({
								title: "Success",
								message: `Action Rejected Successfully`,
								type: "Success",
							});
							this.currentIndex = this.currentIndex + 1;
							let new_item = this.tableDataActionPlan[this.currentIndex];
							console.log(
								this.currentIndex,
								this.tableDataActionPlan.length,
								"this.tableDataActionPlanthis.tableDataActionPlan"
							);
							setTimeout(() => {
								if (this.currentIndex != this.tableDataActionPlan.length)
									this.$emit("show_submit_page", new_item);
							}, 300);
						});
					} else {
						this.$notify.error({
							title: "fail",
							message: "Enter required fields",
						});
					}
				});
			} else {
				let params = [
					{
						id: this.storeObjSubmit.id,
						status: type,
						rejection_reason: "",
					},
				];
				formBuilderServices.ApproveRejectActionFlow(params).then((res) => {
					this.fileURLArray = [];
					this.$emit("recall_page_2", this.storeObj);
					this.$notify.success({
						title: "Success",
						message: `Action Approved Successfully`,
						type: "Success",
					});
					this.currentIndex = this.currentIndex + 1;
					let new_item = this.tableDataActionPlan[this.currentIndex];
					console.log(
						this.currentIndex,
						this.tableDataActionPlan.length,
						"this.tableDataActionPlanthis.tableDataActionPlan"
					);
					setTimeout(() => {
						if (this.currentIndex != this.tableDataActionPlan.length)
							this.$emit("show_submit_page", new_item);
					}, 300);
				});
			}
		},
		// approveRejectAPI(type) {
		// 	let callApi = type != "rejected" || this.$validator.validateAll();

		// 	if (callApi) {
		// 		let params = {
		// 			id: this.storeObjSubmit.id,
		// 			status: type,
		// 			rejection_reason: type == "rejected" ? this.reason : "",
		// 		};

		// 		formBuilderServices
		// 			.ApproveRejectActionFlow([params])
		// 			.then((res) => {
		// 				this.fileURLArray = [];
		// 				let type1 = type == "rejected" ? "Rejected" : "Approved";
		// 				this.$emit("recall_page_2", this.storeObj);
		// 				this.$notify.success({
		// 					title: "Success",
		// 					message: `Action ${type1} Successfully`,
		// 					type: "success", // should be lowercase "success"
		// 				});
		// 				this.currentIndex += 1;
		// 				let new_item = this.tableDataActionPlan[this.currentIndex];
		// 				console.log(
		// 					this.currentIndex,
		// 					this.tableDataActionPlan.length,
		// 					"this.tableDataActionPlanthis.tableDataActionPlan"
		// 				);
		// 				setTimeout(() => {
		// 					if (this.currentIndex < this.tableDataActionPlan.length) {
		// 						this.$emit("show_submit_page", new_item);
		// 					}
		// 				}, 300);
		// 			})
		// 			.catch(() => {
		// 				this.$notify.error({
		// 					title: "Fail",
		// 					message: "Failed to perform action",
		// 				});
		// 			});
		// 	} else {
		// 		this.$notify.error({
		// 			title: "Fail",
		// 			message: "Enter required fields",
		// 		});
		// 	}
		// },

		// async listProjectsData() {
		// 	this.projectsTasksItems = [];
		// 	try {
		// 		const res = await formBuilderServices.getProjectsTasksList();
		// 		console.log(res, "res");
		// 		let projectsTasksItems = JSON.parse(res.data).data;
		// 		console.log(projectsTasksItems, "projectsTasksItems1");
		// 		this.projectsTasksItems = projectsTasksItems.sort((a, b) =>
		// 			a.name < b.name ? -1 : 1
		// 		);
		// 		console.log(this.all_projects, "this.all_projects");
		// 		let projectsTasksItems1 = this.all_projects.map((el) => {
		// 			console.log(el, "el");
		// 			return { name: el, id: el };
		// 		});
		// 		console.log(projectsTasksItems1, "this.projectsTasksItems22 ");
		// 		this.projectsTasksItems.unshift({ name: "All Projects", id: "All" });
		// 		this.projectsTasks = "All";
		// 	} catch (e) {
		// 		console.log(e, "err");
		// 	}
		// },
		async listSummaryData() {
			this.actionSummaryData = {};
			try {
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.location.length == 0) {
						this.location = this.locationItems[0].id;
					} else {
						if (typeof this.location != "string") {
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastElement.push(this.location[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.location];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.location) {
						this.location = [];
					} else {
						lastIndex = 3;
						lastElement = this.location;
					}
					// else{
					// 	lastElement = [this.location];
					// }
				}
				let projectsTasks = this.projectsTasksItems.filter((el) =>
					el.id.includes(this.projectsTasks)
				)[0].name;
				projectsTasks = projectsTasks != "All Projects" ? [projectsTasks] : [];
				console.log(projectsTasks, this.projectsTasksItems, "projectsTasks");
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					search: "",
					projects_list: projectsTasks,
					submitted_by_list: [],
					designation_list: [],
					grade_list: [],
					status_list: [],
					sort_on: "",
					sort_by: "",
				};
				const res = await formBuilderServices.listActionsSummary(params);
				console.log(JSON.parse(res.data), "resss11");
				this.actionSummaryData = JSON.parse(res.data);
			} catch (e) {
				console.log(e, "err");
			}
		},
		open_submit_confirmation_popup() {
			// let currentDate = new Date();
			// let checkDate = new Date(this.storeObj.due_date);
			// if (this.storeObj.status == "completed"&& checkDate < currentDate) {
			// 	this.confirmationTitle = "Alert!";
			// 	this.confirmationText = "Submit Action before leaving?";
			// 	this.alertType = "1";
			// 	this.submitDialog = true;
			// } else {
			this.$emit("hide_view_page");
			// }
		},
		call_cancel_btn(alertType) {
			console.log(alertType, 'this.$emit("hide_view_page");');
			if (alertType == "1") {
				this.$emit("hide_view_page");
				this.submitDialog = false;
				this.actionObject = {};
			} else {
				this.submitDialog = false;
				this.actionObject = {};
			}
		},
		call_submit_confirmation_api(item) {
			this.loading = true;
			console.log("hi", item);
			let params = {
				project_execution_id: item.id,
				actions_status: "submitted",
			};
			formBuilderServices
				.submitActions(params)
				.then((res) => {
					console.log(res, "rees");
					this.$emit("hide_view_page");
					this.$notify.success({
						title: "Success",
						message: "Action Updated!",
						type: "Success",
					});

					this.loading = false;
					this.submitDialog = false;
				})
				.catch((err) => {
					this.$notify.error({
						title: "fail",
						message: err.message,
					});
					this.loading = false;
					this.submitDialog = false;
				});
		},
		submit_action(item) {
			this.actionObject = item;
			this.confirmationTitle = "Alert!";
			this.confirmationText =
				"All actions are completed. Do you wish to Submit?";
			console.log("ss", item);
			this.submitDialog = true;
		},
		async list_all_filters() {
			console.log(this.location, "this.location");
			try {
				// let location = this.location;
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.location.length == 0) {
						this.location = this.locationItems[0].id;
					} else {
						if (typeof this.location != "string") {
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastElement.push(this.location[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.location];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.location) {
						this.location = [];
					} else {
						lastIndex = 3;
						lastElement = this.location;
					}
					// else{
					// 	lastElement = [this.location];
					// }
				}
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				let params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
				};
				const res = await formBuilderServices.listActionsFiltersDataPage1(
					params
				);
				this.all_designations = [];
				this.all_grades = [];
				this.all_projects = [];
				this.all_status = [];
				this.all_submitted_by = [];
				this.all_locations = [];

				let response = JSON.parse(res.data);
				console.log(response, "resp");
				for (let key in response) {
					if (key == "designations") {
						let all_designations = response[key].filter(Boolean);
						this.all_designations.push(all_designations);
					}
					if (key == "grades") {
						let all_grades = response[key].filter(Boolean);
						this.all_grades.push(all_grades);
					}
					if (key == "projects") {
						let all_projects = response[key].filter(Boolean);
						this.all_projects.push(all_projects);
					}
					if (key == "status") {
						let all_status = response[key].filter(Boolean);
						this.all_status.push(all_status);
					}
					if (key == "submitted_by") {
						let filteredSubmittedBy = response[key].filter(Boolean);
						this.all_submitted_by.push(filteredSubmittedBy);
					}
					if (key == "locations") {
						let filteredSubmittedBy = response[key].filter(Boolean);
						this.all_locations.push(filteredSubmittedBy);
					}
				}
				let projectsTasksItems1 = this.all_projects[0].map((item) => ({
					name: item,
					id: item,
				}));
				console.log(projectsTasksItems1, "this.all_projects");
				this.projectsTasksItems = projectsTasksItems1;
				console.log(projectsTasksItems1, "this.projectsTasksItems22 ");
				this.projectsTasksItems.unshift({ name: "All Projects", id: "All" });
				this.projectsTasks = "All";
			} catch (e) {
				console.log(e, "e");
			}
		},
		update_actions(type) {
			if (this.storeObj.status == "submitted") {
				if (type == "next") this.get_prev_next_page_3_response("next");
				if (type == "prev") this.get_prev_next_page_3_response("prev");
			} else {
				this.$validator.validateAll().then((result) => {
					if (result) {
						if (this.page_3_response.attachment_mandatory) {
							if (this.fileURLArray.length == 0) {
								this.$notify.error({
									title: "Fail",
									message: `Upload At least 1 Attachment`,
								});
							} else {
								if (this.fileURLArray.length > 0) {
									this.upload_question_attachments_api(type);
								} else {
									this.call_save_action_api(type);
								}
							}
						} else {
							if (this.fileURLArray.length > 0) {
								this.upload_question_attachments_api(type);
							} else {
								this.call_save_action_api(type);
							}
						}
					} else {
						this.$notify.error({
							title: "Fail",
							message: `Enter required fields`,
						});
					}
				});
			}
		},
		upload_question_attachments_api(type) {
			let count = [...this.fileURLArray].filter((el) => !el.id);
			if (count.length > 0) {
				const formData = new FormData();
				const fetchAndConvertToFile = async (url) => {
					try {
						if (url && typeof url === "object" && url.src) {
							const response = await fetch(url.src);
							const blob = await response.blob();
							const fileName = url.fileDetails.name;
							return new File([blob], fileName);
						} else {
							throw new Error("Invalid URL format");
						}
					} catch (error) {
						console.error("Error fetching or processing file:", error);
						throw error;
					}
				};
				const uploadPromises = [...this.fileURLArray]
					.filter((el) => !el.id)
					.map(async (url, index) => {
						try {
							const file = await fetchAndConvertToFile(url);
							formData.append("attachments", file);
						} catch (error) {
							console.error(
								`Error at index ${index} during file processing:`,
								error
							);
						}
					});
				Promise.all(uploadPromises)
					.then(() => {
						formBuilderServices
							.uploadQuestionAttachment(formData)
							.then((res) => {
								this.uploadedAttachments = JSON.parse(res.data).data;
								this.call_save_action_api(type);
							});
					})
					.catch((error) => {
						console.error("Error during file processing:", error);
					});
			} else {
				this.call_save_action_api(type);
			}
		},
		call_save_action_api(type) {
			let uploadedAttachments = [];
			if (this.uploadedAttachments.length > 0) {
				for (let i = 0; i < this.uploadedAttachments.length; i++) {
					uploadedAttachments.push({
						file_name: this.uploadedAttachments[i].file_name,
						file_path: this.uploadedAttachments[i].file_path,
					});
				}
			}
			let params = {
				action: {
					id: this.page_3_response.id,
					form_question_execution: this.page_3_response.form_question_execution,
					issue_dscription: this.page_3_response.issue_dscription,
					resolved_description: this.page_3_response.resolved_description,
					due_date: this.page_3_response.due_date,
				},
				issue_attachments: this.page_3_response.issue_attachments_info,
				resolved_attachments: uploadedAttachments,
			};
			formBuilderServices.taskAction(params).then((res) => {
				this.fileURLArray = [];
				this.uploadedAttachments = [];
				if (this.storeObj.status != "submitted") {
					this.$notify.success({
						title: "Success",
						message: "Action Updated Successfully",
						type: "Success",
					});
				}

				if (type == "next") this.get_prev_next_page_3_response("next");
				if (type == "prev") this.get_prev_next_page_3_response("prev");
				if (type == null) this.$emit("recall_page_2", this.storeObj);
				// this.show_page_2();
			});
		},
		get_page3_userInput_values(item) {
			if (
				item &&
				item.input_type_info &&
				item.input_type_info.name === "Yes / No"
			) {
				return item.form_question_execution_info.boolean_input ? "Yes" : "No";
			}
		},
		exportCSV() {
			this.downloadCSV(this.storeObj);
			return;
			this.addDownloadingReportCountAction("Report");
			console.log(this.tableDataActionPlan, "this.tableDataActionPlan");
			let data = [...this.tableDataActionPlan].map((el) => ({
				Step: el.form_question,
				"Created On":
					el.created_on != null
						? this.moment(el.created_on).local().format("Do MMM YYYY")
						: "-",
				Category: el.form_category,
				Form: el.form,
				"User Input": el.user_input,
				Comment: el.question_comment != null ? el.question_comment : "-",
				"Question Attachments": el.question_attachments
					.map((url) => `${url}\n`)
					.join(""),
				"Action Raised Comment":
					el.action_raised_comment != null ? el.action_raised_comment : "-",
				"Action Raised Attachments": el.action_raised_attachments
					.map((url) => `${url}\n`)
					.join(""),
				"Action Taken Comment":
					el.action_taken_comment != null ? el.action_taken_comment : "-",
				"Action Taken Attachments": el.action_taken_attachments
					.map((url) => `${url}\n`)
					.join(""),
				"Due Date":
					el.due_date != null
						? this.moment(el.due_date).local().format("Do MMM YYYY")
						: "-",
				Status: el.status == "in_progress" ? "In progress" : "Completed",
			}));
			const fileName = `Action Report ${
				this.locationItems.length != 0
					? this.locationItems.filter((el) => el.id.includes(this.location))[0]
							.name
					: "-"
			} ( ${this.storeObj.name} )`;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
			this.removeDownloadingReportCountAction();
		},
		exportPDFReport() {
			this.isPDFLoading = true;
			this.addDownloadingReportCountAction("Report");
			let params = {
				project_execution_id: this.storeObj.id,
			};
			formBuilderServices.getActionsPDFreport(params).then((res) => {
				this.five_k_report_data = JSON.parse(res.data);
				EventBus.$emit("loadActionPdfFirst");
			});
		},
		downloadCSV(item) {
			this.addDownloadingReportCountAction("Report");
			const params = {
				project_execution_id: item.id,
			};
			formBuilderServices
				.downloadActionsCSV(params)
				.then((response) => {
					const blob = new Blob([response.data], { type: "text/csv" });
					const fileName = `Action Report ${
						this.locationItems.length != 0
							? this.locationItems.filter((el) =>
									el.id.includes(this.location)
							  )[0].name
							: "-"
					} ( ${this.storeObj.name} ).csv`;

					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.setAttribute("download", fileName);
					link.click();
					window.URL.revokeObjectURL(link.href); // Clean up
					this.removeDownloadingReportCountAction();
				})
				.catch((err) => {
					console.error(err);
					this.removeDownloadingReportCountAction();
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				});
		},
		downloadCsvReport(item) {
			this.addDownloadingReportCountAction("Report");
			var params = {
				project_execution: item.id,
			};
			formBuilderServices
				.getDashboarLocationReport(params)
				.then((response) => {
					let fileURL =
						"data:application/pdf;charset=UTF-8," +
						encodeURIComponent(response.data);
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute(
						"download",
						`${item.name} - ${
							`${
								this.locationItems.length != 0
									? this.locationItems.filter((el) =>
											el.id.includes(this.location)
									  )[0].name
									: "-"
							} - ` +
							item.start_date +
							"/" +
							item.end_date +
							".pdf"
						}`
					);
					document.body.appendChild(fileLink);
					fileLink.click();
					this.removeDownloadingReportCountAction();
				})
				.catch((err) => {
					console.log(err);
					this.removeDownloadingReportCountAction();
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				});
		},
		async list_all_locations() {
			this.allLocations = [];
			this.isDomLoading = true;
			formBuilderServices.listAllLocations().then(async (res) => {
				this.allLocations = JSON.parse(res.data);
				this.allLocations.sort((a, b) => b.name - a.name);
				console.log(this.allLocations, "this.allLocations");

				// this.location =
				// 	Object.keys(this.$route.query).length && this.$route.query.outlet_id
				// 		? this.$route.query.outlet_id
				// 		: this.locationItems[0].id;
				this.$forceUpdate();
				await this.listCountries();
				await this.list_all_filters();
				// await this.listProjectsData();
				console.log("he");
				await this.listSummaryData();
				this.list_actions_page1(
					this.currentPage,
					this.perPage,
					this.selected_project,
					this.selectedLocation,
					this.selected_designation,
					this.selected_grade,
					this.selected_status,
					this.search
				);
			});
		},
		get_page(newPage) {
			this.currentPage = newPage;
			this.pagination.currentPage = newPage;
			this.list_actions_page1(
				newPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
		},
		handleInput() {
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(() => {
				this.list_actions_page1(
					this.currentPage,
					this.perPage,
					this.selected_project,
					this.selectedLocation,
					this.selected_designation,
					this.selected_grade,
					this.selected_status,
					this.search
				);
			}, 300);
		},
		async list_actions_page1(
			page,
			per_page,
			project,
			submitted_by,
			designation,
			grade,
			status,
			search,
			type
		) {
			this.tableVisible = false;
			try {
				console.log(this.locationItems, "this.locationItems");
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.location.length == 0) {
						this.location = this.locationItems[0].id;
					} else {
						if (typeof this.location != "string") {
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.location.length; i++) {
								for (let j = 0; j < this.location[i].length; j++) {
									lastElement.push(this.location[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.location];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.location) {
						this.location = [];
					} else {
						lastIndex = 3;
						lastElement = this.location;
					}
					// else{
					// 	lastElement = [this.location];
					// }
				}
				let projectsTasks = this.projectsTasksItems.filter((el) =>
					el.id.includes(this.projectsTasks)
				)[0].name;
				projectsTasks = projectsTasks != "All Projects" ? [projectsTasks] : [];
				// let location = this.location != "All" ? [this.location] : [];
				let sort_by = "";
				if (this.completedOn_order) sort_by = "date_of_completion";
				if (this.dueDate_order) sort_by = "actions_due_date";
				let allResults = [];
				let start_date = moment(this.dates[0]).format("yyyy-MM-DD");
				let end_date = moment(this.dates[1]).format("yyyy-MM-DD");
				for (let currentPage = 1; currentPage <= page; currentPage++) {
					const params = {
						filters: {
							outlets: lastIndex == 3 ? lastElement : [],
							countries: lastIndex == 0 ? lastElement : [],
							regions: lastIndex == 1 ? lastElement : [],
							subregions: lastIndex == 2 ? lastElement : [],
						},
						start_date: start_date,
						end_date: end_date,
						search: search,
						projects_list: project.length != 0 ? project : projectsTasks,
						location_list: this.selectedLocation,
						submitted_by_list: [],
						designation_list: designation,
						grade_list: grade,
						status_list: status,
						sort_on:
							sort_by === "date_of_completion"
								? this.completedOn_order
								: sort_by === "actions_due_date"
								? this.dueDate_order
								: "",
						sort_by: sort_by,
					};
					const res = await formBuilderServices.listActionsPage1(
						currentPage,
						per_page,
						params
					);

					const responseData = JSON.parse(res.data);
					console.log(responseData, "responseData");
					if (currentPage === page) {
						this.list_count = responseData.count;
					}
					allResults = [...allResults, ...responseData.data];
				}
				this.tableData = allResults;
				if (type == "refresh") {
					console.log(this.storeObj, this.tableData, "refreshrefreshrefresh");
					let storeObj = {};
					storeObj = this.tableData.find((obj) => obj.id === this.storeObj.id);
					console.log(storeObj, "storeObjstoreObjstoreObj");
					this.$emit("refresh_to_page_2", storeObj);
					this.$forceUpdate();
				}
				this.isDomLoading = false;
				this.$nextTick(() => {
					this.tableVisible = true;
				});
			} catch (error) {
				console.error("Error fetching licenses:", error);
				this.isDomLoading = false;
			}
		},
		handlePickerClose() {
			this.list_actions_page1(
				this.currentPage,
				this.perPage,
				this.selected_project,
				this.selectedLocation,
				this.selected_designation,
				this.selected_grade,
				this.selected_status,
				this.search
			);
			this.listSummaryData();
			this.list_all_filters();
		},
		list_actions_page2() {
			this.tableVisible = false;
			this.isDomLoading = true;
			let params = {
				project_execution_id: this.storeObj.id,
			};
			formBuilderServices.listActionsPage2(params).then((res) => {
				this.tableDataActionPlan = JSON.parse(res.data);
				this.completedCountAction = 0;
				this.checkedAll = false;
				for (let i = 0; i < this.tableDataActionPlan.length; i++) {
					this.tableDataActionPlan[i].checked = false;
					if (this.tableDataActionPlan[i].status == "approved") {
						this.completedCountAction += 1;
					}

					this.tableDataActionPlan[i].idx = i;
				}
				console.log("tableDataActionPlan", this.tableDataActionPlan);
				this.isDomLoading = false;
				this.$nextTick(() => {
					this.tableVisible = true;
				});
				this.$forceUpdate();
			});
		},
		get_prev_next_page_3_response(type) {
			let new_item = {};
			if (type == "prev") {
				this.currentIndex = this.currentIndex - 1;
				new_item = this.tableDataActionPlan[this.currentIndex];
			}
			if (type == "next") {
				this.currentIndex = this.currentIndex + 1;
				new_item = this.tableDataActionPlan[this.currentIndex];
			}
			this.$emit("show_submit_page", new_item);
		},
		list_actions_page3() {
			this.isDomLoading = true;
			formBuilderServices
				.listActionsPage3(this.storeObjSubmit.id)
				.then(async (res) => {
					this.page_3_response = JSON.parse(res.data);
					console.log(this.page_3_response, "page_3_response");
					if (this.page_3_response.resolved_attachments_info.length != 0) {
						await this.get_image(
							this.page_3_response.resolved_attachments_info,
							null,
							0
						);
					}
					this.isDomLoading = false;
				});
		},
		async get_image(arr, type, idx) {
			console.log(idx, "idddxxx");
			console.log(this.currentItemIndex, "this.currentItemIndex");
			await Promise.all(
				arr.map(async (el) => {
					el.fileDetails = { name: "" };
					try {
						const params = {
							file_path: el.file_path,
							storage: "task",
						};
						const res = await formBuilderServices.getAttachmentURL(params);
						el.src = JSON.parse(res.data).data;
						el.fileDetails = { name: el.file_name };
					} catch (error) {
						console.error("Error fetching attachment URL:", error);
					}
				})
			);
			if (type != null) {
				console.log(type, arr, "type");
				setTimeout(() => {
					if (type == "1") {
						this.fileURLArray1 = arr;
						this.clicked_val = type;
					}
					if (type == "2") {
						this.fileURLArray2 = arr;
						this.clicked_val = type;
					}
					if (type == "3") {
						this.fileURLArray3 = arr;
						this.clicked_val = type;
					}
					// this.fileURLArray = arr;
					setTimeout(() => {
						this.currentItemIndex = idx;
						this.previewLicenseDialog = true;
					}, 100);
				}, 50);
			} else {
				this.fileURLArray = arr;
			}
			console.log(this.fileURLArray, arr, "this.fileURLArray");
			this.$forceUpdate();
			return arr;
		},
		action_row_click(item) {
			console.log(item, "item");
			this.$emit("show_view_page", item);
		},
		action_plan_row_click(item, idx) {
			this.currentIndex = idx;
			console.log(this.currentIndex, "ci");

			this.$emit("show_submit_page", item);
		},
		show_page_2() {
			this.$emit("show_view_page", this.storeObj);
		},
		show_page_3() {
			this.$emit("show_submit_page", this.storeObjSubmit);
			this.previewLicenseDialog = false;
		},
		show_page_4() {
			this.$emit("show_page_2", this.storeObjSubmit);
		},
		// upload_file_handler(event) {
		// 	const fileInput = event.target; // Accessing the input element from the event
		// 	const files = Array.from(fileInput.files);
		// 	if (files.length > 5) {
		// 		alert("Please select up to 5 files only.");
		// 		return;
		// 	}
		// 	files.forEach((file) => {
		// 		const indexToRemove = this.fileURLArray.findIndex(
		// 			(uploadedFile) => uploadedFile.fileDetails.name === file.name
		// 		);
		// 		if (indexToRemove !== -1) {
		// 			this.fileURLArray.splice(indexToRemove, 1);
		// 		}
		// 	});
		// 	this.fileURLArray = this.fileURLArray.concat(
		// 		files.map((file) => ({
		// 			fileDetails: file,
		// 			src: URL.createObjectURL(file),
		// 		}))
		// 	);
		// },
		upload_file_handler(event) {
			const fileInput = event.target; // Accessing the input element from the event
			const files = Array.from(fileInput.files);
			const totalFiles = this.fileURLArray.length + files.length;
			if (totalFiles > 5) {
				alert("Please select up to 5 files only.");
				return;
			}
			files.forEach((file) => {
				const indexToRemove = this.fileURLArray.findIndex(
					(uploadedFile) => uploadedFile.fileDetails.name === file.name
				);
				if (indexToRemove !== -1) {
					this.fileURLArray.splice(indexToRemove, 1);
				}
			});
			this.fileURLArray = this.fileURLArray.concat(
				files.map((file) => ({
					fileDetails: file,
					src: URL.createObjectURL(file),
				}))
			);
		},
		delete_file_list(item) {
			if (item.id) {
				let params = {
					id: item.id,
				};
				console.log(params, "params");
				formBuilderServices.deleteActionAttachmentPage3(params).then((res) => {
					console.log(res, "res");
				});
			}
			const indexToRemove = this.fileURLArray.findIndex(
				(file) => file.fileDetails.name === item.fileDetails.name
			);
			if (indexToRemove !== -1) {
				this.fileURLArray.splice(indexToRemove, 1);
			}
			const fileInput = this.$refs.fileUploadSelector;
			fileInput.value = null;
			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "Success",
			});
		},
		preview_license(item, idx) {
			this.currentItemIndex = idx;
			this.imgObject = item;
			this.previewLicenseDialog = true;
		},
	},
};
</script>

<style lang="scss">
.actions {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.actions-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 14px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 50vh;
			max-height: 50vh;
		}
	}
	.actions-table1 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 14px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 50vh;
			max-height: 50vh;
		}
	}
}
.button-class-white2 {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
}
.button-class2 {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
}
.input-class .el-input__inner {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 25px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
}
.custom-table {
	width: 100%;
	align-items: left;
}
.custom-table th,
.custom-table td {
	padding: 10px;
	text-align: left;
	border-bottom: 1px solid #ddd;
}
.table-wrapper {
	height: 55vh; /* Adjust the height as needed */
	overflow-y: auto;
}

.table-wrapper table {
	width: 100%;
	border-collapse: collapse;
}

.table-wrapper thead,
.table-wrapper tbody tr {
	display: table;
	width: 100%;
	table-layout: fixed;
}

.table-wrapper thead {
	width: calc(100% - 1em);
	position: sticky;
	top: 0;
	z-index: 2;
	background-color: white; /* Ensure the header background is visible */
}

.table-wrapper tbody {
	display: block;
	height: calc(100% - 2.5em); /* Adjust the height as needed */
	overflow-y: auto;
}

.table-wrapper th,
.table-wrapper td {
	text-align: left;
}
</style>
